import React from "react";
import EstadisticasCanal from "./EstadisticasCanal";
export default function EstadisticasMasivo(){ return <EstadisticasCanal canal="masivo" />; }
